import script from "./LoginConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./LoginConfirmation.vue?vue&type=style&index=0&id=98204f12&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98204f12"]])

export default __exports__